import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media print {
    @page {
      size: landscape;
      size: 365mm 210mm;
    }
  }

  h3 {
    font-weight: 400;
    font-size: 16px;
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
  }

  tbody:last-child {
    background-color: ${({ theme }) => theme.colors.orange.primary};
  }

  .itemClicavel a {
    font-weight: 700;
    color: inherit;
    text-decoration: inherit;
    color: ${({ theme }) => theme.colors.orange.primary};

    transition: filter 0.2s ease-in;

    &:hover {
      filter: brightness(0.8);
    }
  }

  .anticipateButton {
    margin: 0 auto;
    background: ${({ theme }) => theme.colors.orange.primary};
    border-radius: 4px;
    padding: 7px 8px;
    width: fit-content;

    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};

    line-height: normal;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  align-items: end;
  gap: 16px;

  /* auto-fit + minmax deixa os filtros quebrarem em linhas quando falta largura;
     com repeat(9, 1fr) as colunas nao encolhem abaixo do conteudo (1fr == minmax(auto, 1fr))
     e os botoes do fim vazam a direita (ex: zoom 125%) */
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));

  > * {
    min-width: 0;
  }
`;
